// ─── Version (Core) ───────────────────────────────────────────────
// Chaque app de la suite a SA version ; le Core fournit le comparateur et les
// valeurs par défaut. Une app peut surcharger nom/version via <CoquilleApp>.
export const APP_NAME    = 'MoP Suite';
export const APP_VERSION = '0.1.0';

// Version du CORE PARTAGÉ (@mop/core) — semver 3 segments, bumpée à CHAQUE
// modification du Core :
//   • MAJEUR : rupture d'API interne (casse les apps)
//   • MINEUR : nouvelle brique / nouvel export (composant, hook, service)
//   • PATCH  : correctif, cosmétique, perf — sans changement d'API
// À chaque bump : reporter dans packages/core/package.json et mentionner
// « Core vX.Y.Z » dans le sujet (ou corps) du commit → scripts/
// ivv-version-events.js pose l'événement sur « MoP Suite — IVV ».
// Affichée dans Profil → À propos des deux apps.
export const CORE_VERSION = '2.52.0';

// Vrai si `running` est au moins égal à `cible` (schéma x.y.z.w).
export function versionAuMoins(running, cible) {
  if (!cible) return true;
  const a = String(running || '').split('.').map(n => parseInt(n, 10) || 0);
  const b = String(cible   || '').split('.').map(n => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const x = a[i] || 0, y = b[i] || 0;
    if (x !== y) return x > y;
  }
  return true;
}
